import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const SEASON_LABELS = {
  1: "Season 1 (2015)",
  2: "Season 2 (2016)",
  3: "Season 3 (2017)",
  4: "Season 4 (2018–19)",
  5: "Special (2020)",
};
